import React from 'react';
interface ResultSummaryProps {
  summary: {
    overall: string;
    weaknesses: string[];
    strengths: string[];
    businessImpact: string;
  };
}
export const ResultSummary: React.FC<ResultSummaryProps> = ({
  summary
}) => {
  return <div className="mb-12" data-id="element-248">
      <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-249">
        Analysis & Insights
      </h3>
      <div className="bg-white rounded-lg border shadow-sm overflow-hidden" data-id="element-250">
        <div className="p-6 border-b" data-id="element-251">
          <h4 className="font-medium text-gray-800 mb-2" data-id="element-252">Overall Assessment</h4>
          <p className="text-gray-700" data-id="element-253">{summary.overall}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-254">
          <div className="p-6 border-b md:border-b-0 md:border-r" data-id="element-255">
            <h4 className="font-medium text-gray-800 mb-3 flex items-center" data-id="element-256">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2" viewBox="0 0 20 20" fill="currentColor" data-id="element-257">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-258" />
              </svg>
              Key Areas for Improvement
            </h4>
            <ul className="space-y-2" data-id="element-259">
              {summary.weaknesses.map((weakness, index) => <li key={index} className="flex items-start" data-id="element-260">
                  <span className="text-red-500 mr-2" data-id="element-261">•</span>
                  <span className="text-gray-700" data-id="element-262">{weakness}</span>
                </li>)}
            </ul>
          </div>
          <div className="p-6" data-id="element-263">
            <h4 className="font-medium text-gray-800 mb-3 flex items-center" data-id="element-264">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500 mr-2" viewBox="0 0 20 20" fill="currentColor" data-id="element-265">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-266" />
              </svg>
              Business Strengths
            </h4>
            <ul className="space-y-2" data-id="element-267">
              {summary.strengths.map((strength, index) => <li key={index} className="flex items-start" data-id="element-268">
                  <span className="text-green-500 mr-2" data-id="element-269">•</span>
                  <span className="text-gray-700" data-id="element-270">{strength}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="p-6 bg-blue-50" data-id="element-271">
          <h4 className="font-medium text-blue-800 mb-2 flex items-center" data-id="element-272">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor" data-id="element-273">
              <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" data-id="element-274" />
            </svg>
            Business Impact
          </h4>
          <p className="text-blue-700" data-id="element-275">{summary.businessImpact}</p>
        </div>
      </div>
    </div>;
};